import { render, staticRenderFns } from "./MediaStats.vue?vue&type=template&id=021f10e6&scoped=true"
import script from "./MediaStats.vue?vue&type=script&lang=js"
export * from "./MediaStats.vue?vue&type=script&lang=js"
import style0 from "./MediaStats.vue?vue&type=style&index=0&id=021f10e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021f10e6",
  null
  
)

export default component.exports